import React from 'react';
import './Logo.css';

const Logo: React.FC = () => {
  return (
    <div className="logo">
      <div className="logo-mark">
        <img src="/logo.svg" alt="Gioco per tutti" className="logo-image" />
      </div>
      <div className='logo-text'>
        <div>Gioco per tutti</div>
        <small style={{color: 'var(--muted)'}}>Associazione no-profit</small>
      </div>
    </div>
  );
};

export default Logo;



